export const riskMapConfigs = {
  riskMap: {
    id: "riskMap",
    type: "raster",
    isDynamic: true,
    sourceId: "riskMap-raster-source",
    layerId: "riskMap-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/risk/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
  },
};
